// extracted by mini-css-extract-plugin
module.exports = {"container":"FacetBar_container__1Abg3"};